import React, { useContext, useEffect } from 'react'
import { Form, Select } from 'semantic-ui-react'
import { BookerContext } from '../../../contexts/BookerContext'
import { CampProps } from '../../../interfaces'
import pluralize from '../../../utils/pluralize'
import { MinusCircleIcon, PlusCircleIcon } from '@heroicons/react/24/outline'
import classNames from '../../../utils/classNames'

interface ComponentProps {
  camp: CampProps
  userPets: number
  setUserPets: React.Dispatch<React.SetStateAction<number>>
  petsCapacity: number
  error: string
  setError: (v: string) => void
}

const PetsField = ({ camp, userPets, setUserPets, petsCapacity, error, setError }: ComponentProps) => {
  const isPetsMinusDisabled = !userPets || userPets <= 0
  const isPetsPlusDisabled = (userPets || 0) === petsCapacity

  useEffect(() => {
    if(userPets > petsCapacity){
      setUserPets(petsCapacity)
    }
  }, [])

  return (
    <div>
      <div className='flex justify-between items-center '>
        <Form.Field required className='flex flex-col'>
          <div className='font-bold text-lg mb-1'>Pets</div>
        </Form.Field>
        <div className='flex items-center flex-col xs:flex-row-reverse'>
          <div className='flex items-center'>
            <button
              className=''
              onClick={(e) => {
                {
                  setError('')
                  !isPetsMinusDisabled && setUserPets(userPets - 1)
                }
              }}
            >
              <MinusCircleIcon className={classNames('w-8 h-8 cursor-pointer', isPetsMinusDisabled && 'text-gray-300')} />
            </button>
            <input
              type='number'
              aria-label="pets count"
              value={userPets || 0}
              className='numberInputWithoutArrows text-center'
              onChange={(e) => {
                setError('')
                
                const value = parseInt(e.target.value, 10) || 0

                if (value < 0) {
                  setUserPets(0)
                } else if (!!petsCapacity && value > petsCapacity) {
                  setUserPets(petsCapacity)
                } else {
                  setUserPets(value)
                }
              }}
              style={{
                background: 'transparent',
                border: 'none',
                width: 55,
                padding: 0,
                fontSize: 18,
              }}
            />
            <button
              className=''
              onClick={(e) => {
                setError('')
                !isPetsPlusDisabled && setUserPets((userPets || 0) + 1)
              }}
            >
              <PlusCircleIcon className={classNames('w-8 h-8 cursor-pointer', isPetsPlusDisabled && 'text-gray-300')} />
            </button>
          </div>
          {petsCapacity && isPetsPlusDisabled ? <div className='top-2 xs:top-0 xs:mr-3 text-red-600 font-medium'>{petsCapacity} pets max</div> : <></>}
        </div>
      </div>
      {error?.length ? <div className='text-red-600 font-semibold'>{error}</div> : <></>}
    </div>
  )
}

export default PetsField
